// UserCategoriesCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import { EMPTY_ARRAY } from '../resource/defaults.js';
import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import UniversalContainer from '../component/UniversalContainer.jsx';
import { createCategoryLoader } from '../resource/createCategoryLoader.js';
import useSSRDataMerge from '../hook/useSSRDataMerge.js';

export const loader = createCategoryLoader({
  pathPrefix: 'user-categories',
  categoryType: 'creators',
  loaderName: 'UserCategoriesCategory',
});

const UserCategoriesCategoryRoute = () => {
  const { data, error, meta = EMPTY_ARRAY } = useLoaderData();

  useSSRDataMerge({
    componentName: 'UserCategoriesCategory',
    loaderData: data,
    loaderError: error,
  });

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <UniversalContainer filename="UserMore" />
    </>
  );
};

export default UserCategoriesCategoryRoute;
